import { Splide } from "@splidejs/splide"
import '@splidejs/splide/dist/css/splide-core.min.css';


export const sliders = (() => {
	const init = () => {
		const sliderContainers = document.querySelectorAll(
			".splide:not(.is-initialized)"
		)

		sliderContainers.forEach((sliderContainer) => {
			const slider = new Splide(sliderContainer)

			slider.mount()
		})
	}

	return {
		init,
	}
})()
